/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */

export interface IVendorDetails {
  vendorId: string;
  vendorName: string;
}

export interface IJobDetails {
  parentWorkOrderId: string;
  jobNumber: number;
  jobId: string;
}

export enum JobManagementType {
  AllJobs = 'AllJobs',
  AllSchedules = 'AllSchedules',
}

export enum JobsAccessorKey {
  JobNumber = 'jobNumber',
  JobName = 'jobName',
  JobAddress = 'jobAddress',
  JobType = 'jobType',
  CustomerName = 'customerName',
  VendorName = 'vendorName',
  FulfillmentType = 'fulfillmentType',
  City = 'city',
  StateCode = 'stateCode',
  VendorNumber = 'vendorNumber',
  VendorAdminName = 'vendorAdminName',
  VendorAdminEmail = 'vendorAdminEmail',
  WorkTicketNumber = 'workTicketNumber',
  WorkOrderStatus = 'workOrderStatus',
  CreatedOn = 'createdOn',
}

export enum FacilityCoordinates {
  latitude = 'latitude',
  longitude = 'longitude',
}

export enum GeoFence {
  ON = 'ON',
  OFF = 'OFF',
}

export interface SelectedLocationCardProps {
  currentAddress: string | undefined;
  loading: boolean;
  latitude: number | null;
  longitude: number | null;
  isError?: boolean;
  handleSubmit: (lat?: number, lng?: number) => void;
}

export interface JobRow {
  jobId?: string;
  woScheduleMasterId?: string;
  workOrderScheduleId?: string;
}

export enum CreateScheduleFieldNames {
  scheduleName = 'scheduleName',
  scheduleStartDate = 'scheduleStartDate',
  scheduleEndDate = 'scheduleEndDate',
  shiftStartTime = 'shiftStartTime',
  shiftEndTime = 'shiftEndTime',
}

export enum FieldNames {
  startDate = 'startDate',
  startTime = 'startTime',
  endTime = 'endTime',
  endDate = 'endDate',
  jobName = 'jobName',
  instructions = 'instructions',
  bidDueDate = 'bidDueDate',
  searchedVendors = 'searchedVendors',
  shiftStartDate = 'shiftStartDate',
  shiftEndDate = 'shiftEndDate',
  dateFormat = 'YYYY-MM-DD',
  punchInDate = 'punchInDate',
  punchInTime = 'punchInTime',
  punchOutDate = 'punchOutDate',
  punchOutTime = 'punchOutTime',
}

export type ManageScheduleCreationInput = {
  jobId: string;
  facilityId?: string | null;
  workOrderId?: string | null;
  scheduleName?: string | null;
  mdScheduleType?: string | null;
  scheduleDays?: string | null;
  scheduleStartDate?: Date | null;
  scheduleEndDate?: Date | string | null;
  shiftStartTime?: string | null;
  shiftEndTime?: string | null;
  mdShiftType?: string | null;
  endDateOffset?: number | null;
  punchInGraceMinutes?: number | null;
  punchOutGraceMinutes?: number | null;
  totalFTE?: number | null;
  scheduleServices?: Array<{
    mdServiceId: string;
    mdServiceName?: string | null;
    tasks?: Array<{
      taskId: string;
      taskName?: string | null;
    } | null> | null;
  }> | null;
};

export interface SelectedJob {
  jobId: string;
  jobNumber: string;
  workOrderId: string;
  latitude?: number;
  longitude?: number;
  facilityId: string;
  customerId?: string;
  geoFenceRadius?: number;
}

export interface ApiResponse<T = unknown> {
  data?: T;
  isSuccess?: boolean;
}

export type SyncFacilityCoordinates = {
  jobNumber: string;
  jobId?: string;
  workOrderId?: string | null;
  geoCoordinates?: {
    latitude: string;
    longitude: string;
  };
  geoRadius?: string;
};

export type FormValues = {
  startDate: Date | null;
  endDate: Date | null;
};

export type AdhocShiftsPayload = {
  jobNumber: string;
  employeeNumber: string | null;
  workTicketNumber?: string | null;
  scheduleStartDate?: Date | null;
  shiftStartTime?: string | null;
  shiftEndTime?: string | null;
  daysExtendedBy?: number | null;
  scheduleEndDate?: string | null;
  source: string | null;
};

export type RetrospectiveShiftsPayload = {
  jobNumber: string;
  employeeNumber: string | null;
  workTicketNumber?: string | null;
  scheduleStartDate?: Date | null;
  shiftStartTime?: string | null;
  shiftEndTime?: string | null;
  daysExtendedBy?: number | null;
  scheduleEndDate?: string | null;
  source: string | null;
  status?: string | null;
};
